import React from 'react';
import PropTypes from 'prop-types';

import AppBar from './AppBar';
import AppMenu from './AppMenu';
import AppOverview from './AppOverview';
import SystemAlertBar from '@/components/SystemAlertBar';

const ApplicationHeader = ({ routes }) => (
  <>
    <SystemAlertBar />
    <AppBar routes={routes} />
    <AppMenu routes={routes} />
    <AppOverview />
  </>
);

ApplicationHeader.propTypes = {
  routes: PropTypes.array.isRequired,
};

export default ApplicationHeader;
